var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"button",attrs:{"color":"primary","elevation":"0","tile":"","to":{ name: 'my-pathways' }}},[_c('v-icon',{staticClass:"icon"},[_vm._v(" mdi-bookmark-box-multiple ")]),_c('span',{staticClass:"text"},[_vm._v("My Pathways")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }